var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 56,
    viewBox: "0 0 70 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon_Hand"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 56
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Hand",
    clipPath: "url(#clip-Icon_Hand)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14446",
    "data-name": "Group 14446",
    transform: "translate(-5.359 -8.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_123",
    "data-name": "Union 123",
    d: "M33.658,46.139l-26.3-7.551.227-1.754A6.956,6.956,0,0,1,14.949,30.4l5.652.389L1.342,11.324a4.663,4.663,0,0,1,0-6.546,4.559,4.559,0,0,1,6.49,0c2.152,2.176,5.072,5.139,7.945,8.053l4.371-4.41a3.231,3.231,0,0,1,4.6,0l.58.586L29.7,4.6a3.222,3.222,0,0,1,4.6,0l.441.444L38.787.962a3.229,3.229,0,0,1,4.594,0c4.945,4.967,5.141,5.184,13.178,13.317A12.888,12.888,0,0,1,57.671,31l0,0L44.746,44.048l0,0a12.519,12.519,0,0,1-11.084,2.1Z",
    transform: "translate(5.359 8.847)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_122",
    "data-name": "Union 122",
    d: "M0,22.743,22.531,0l7.281,7.35L7.281,30.093Z",
    transform: "translate(45.547 34.753)",
    fill: "#37d131"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHand);
export default __webpack_public_path__ + "static/media/Icon_Hand.f23a50b91f12dab02983d4ca726f74c2.svg";
export { ForwardRef as ReactComponent };